import { useCallback, useEffect, useState } from 'react'
import { DEFAULT_PAGE_SIZE, type NumericFilterState, type OptionFilterState, type PageSize, type SearchSort } from './types'
import { parseSearchUrlState } from './urlState'

export const useSearchFiltersState = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState<PageSize>(DEFAULT_PAGE_SIZE)
  const [selectedBrands, setSelectedBrands] = useState<string[]>([])
  const [selectedTypes, setSelectedTypes] = useState<string[]>([])
  const [priceRange, setPriceRange] = useState({ min: '', max: '' })
  const [numericFilters, setNumericFilters] = useState<NumericFilterState>({})
  const [optionFilters, setOptionFilters] = useState<OptionFilterState>({})
  const [sort, setSort] = useState<SearchSort>('updated-desc')

  useEffect(() => {
    if (typeof window === 'undefined') return
    const syncFromLocation = () => {
      const parsed = parseSearchUrlState(window.location.search)
      setSearchTerm(parsed.searchTerm)
      setPage(parsed.page)
      setPageSize(parsed.pageSize)
      setSelectedBrands(parsed.selectedBrands)
      setSelectedTypes(parsed.selectedTypes)
      setPriceRange(parsed.priceRange)
      setNumericFilters(parsed.numericFilters)
      setOptionFilters(parsed.optionFilters)
      setSort(parsed.sort)
    }

    syncFromLocation()
    window.addEventListener('popstate', syncFromLocation)
    return () => window.removeEventListener('popstate', syncFromLocation)
  }, [])

  // Filters are intentionally local UI state. The search/category URL is the
  // route entry point, not a serialization target for every sidebar change.

  const resetFilters = useCallback(() => {
    setSelectedBrands([])
    setSelectedTypes([])
    setPriceRange({ min: '', max: '' })
    setNumericFilters({})
    setOptionFilters({})
    setPage(1)
  }, [])

  return {
    searchTerm,
    setSearchTerm,
    page,
    setPage,
    pageSize,
    setPageSize,
    selectedBrands,
    setSelectedBrands,
    selectedTypes,
    setSelectedTypes,
    priceRange,
    setPriceRange,
    numericFilters,
    setNumericFilters,
    optionFilters,
    setOptionFilters,
    sort,
    setSort,
    resetFilters,
  }
}
